import {
  Avatar,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Progress,
} from '@chakra-ui/react';
import { myInfoSelector } from '@stores/myInfo';
import { PiMoneyBold } from 'react-icons/pi';
import { useSelector } from 'react-redux';
import { setComma } from 'utils/common';
import { FaSquareParking } from 'react-icons/fa6';
import { RiQuestionFill } from 'react-icons/ri';
import GRADE from '@constants/grade';
import { useTranslation } from 'react-i18next';
import { fetchUserMoney } from '@containers/checkout/queries';

export default function NavProfile() {
  const myInfo = useSelector(myInfoSelector);
  const { t } = useTranslation('home');

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex gap-[6px] items-center mt-[6px]">
        <div>
          <Avatar bg="teal.500" size="sm" />
        </div>
        <p>{myInfo.username}</p>
      </div>
      <div>
        <NavProfileMoney />
        <div className="text-sm">
          <div>
            <Popover isLazy>
              <PopoverTrigger>
                <button className="flex gap-[6px] items-center">
                  <object
                    data={
                    GRADE[
                      myInfo.grade as 'bronze' | 'silver' | 'gold' | 'diamond' | 'platinum'
                    ].svg
                    }
                    width="18px"
                  />
                  <span>{myInfo.grade}</span>
                  <RiQuestionFill />
                </button>
              </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverBody>
                  <table className="text-secondary-900 w-full">
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          <p className="flex items-center gap-[2px]">
                            <object data={GRADE.bronze.svg} width="16px" />
                            Bronze
                          </p>
                        </th>
                        <th>
                          <p className="flex items-center gap-[2px]">
                            <object data={GRADE.silver.svg} width="16px" />
                            Silver
                          </p>
                        </th>
                        <th>
                          <p className="flex items-center gap-[2px]">
                            <object data={GRADE.gold.svg} width="16px" />
                            Gold
                          </p>
                        </th>
                        <th>
                          <p className="flex items-center gap-[2px]">
                            <object data={GRADE.diamond.svg} width="16px" />
                            Diamond
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="[&>tr>td:not(:first-child)]:text-end">
                      <tr>
                        <td className="text-sm">{t('payback')}</td>
                        <td>1%</td>
                        <td>1.5%</td>
                        <td>2%</td>
                        <td>4%</td>
                      </tr>
                    </tbody>
                  </table>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </div>
          <Progress
            value={myInfo.nextGrade}
            size="xs"
            colorScheme="blackAlpha"
          />
        </div>
      </div>
    </div>
  );
}

const NavProfileMoney = () => {
  const { data } = fetchUserMoney();
  if (!data) return <></>;
  return (
    <div className="text-[14px] flex gap-[12px]">
      <dl className="basis-1/2">
        <dt className="flex items-center gap-[4px]">
          <PiMoneyBold />
          Panther Cash
        </dt>
        <dd>{setComma(data.money.cash || 0)}</dd>
      </dl>
      <dl className="basis-1/2">
        <dt className="flex items-center gap-[4px]">
          <FaSquareParking /> Panther Point
        </dt>
        <dd>{setComma(data.money.point || 0)}</dd>
      </dl>
    </div>
  );
};
